/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceSupabase - A library for working with supabase made in Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.
*/

import type { AppRouter } from "@/../../@backend/fastify/routes";
import { Injectable, inject } from "@angular/core";
import { Supabase } from "@app/@classes/supabase";
// import type { AppRouter } from '../../../../../@backend/fastify/routes';
import { createTRPCProxyClient, httpBatchLink } from "@trpc/client";
import { environment } from "src/environments/environment";
import { AuthStateService } from "./auth-state.service";
import { LoggerService } from "./logger.service";

@Injectable({
	providedIn: "root",
})
export class TRPCService extends Supabase {
	private readonly loggerService = inject(LoggerService);
	private readonly authStateService = inject(AuthStateService);

	public client;
	public clientWhatsApp;

	constructor() {
		super();
		const supabase = this.supabaseClient;

		this.client = createTRPCProxyClient<AppRouter>({
			links: [
				httpBatchLink({
					url: `${environment.supabase.url === "http://127.0.0.1:54321" ? "http://127.0.0.1:11000/trpc" : `${environment.supabase.url}/fastify/trpc`}`,
					headers: async () => {
						return {
							Authorization: `Bearer ${
								(await supabase.auth.getSession()).data.session?.access_token
							}`,
							"x-tenant-id": this.authStateService.currentTenantId(),
						};
					},

					// You can pass any HTTP headers you wish here
					// async headers() {
					//   return {
					//     authorization: getAuthCookie(),
					//   };
					// },
				}),
			],
		});

		this.clientWhatsApp = createTRPCProxyClient<AppRouter>({
			links: [
				httpBatchLink({
					url: `${environment.supabase.url === "http://127.0.0.1:54321" ? "http://127.0.0.1:11000/trpc" : `${environment.supabase.url}/whatsapp/trpc`}`,
					headers: async () => {
						return {
							Authorization: `Bearer ${
								(await supabase.auth.getSession()).data.session?.access_token
							}`,
							"x-tenant-id": this.authStateService.currentTenantId(),
						};
					},

					// You can pass any HTTP headers you wish here
					// async headers() {
					//   return {
					//     authorization: getAuthCookie(),
					//   };
					// },
				}),
			],
		});
	}
}
